<template>
  <container style='margin-top: 10px;padding: 25px 30px;'>
    <div class='data-summary fix-box-between'>
      <div class="summary">
        <div class="summary-value">
          <ICountUp
            :delay="delay"
            :endVal="detail.planRentArea"
            :options="options"
          />

        </div>
        <div class="summary-label">
          国有资产计划出租总面积
        </div>
      </div>
      <div class="summary">
        <div class="summary-value" style='color: #FB8B65;'>
          <ICountUp
            :delay="delay"
            :endVal="detail.planReceivedMoneyCount"
            :options="options"
          />
        </div>
        <div class="summary-label">
          计划应收租金金额
        </div>
      </div>
      <div class="summary">
        <div class="summary-value" style='color: #D5C301;'>
          <ICountUp
            :delay="delay"
            :endVal="detail.actualRentArea"
            :options="options"
          />
        </div>
        <div class="summary-label">
          现已出租总面积
        </div>
      </div>
      <div class="summary">
        <div class="summary-value" style='color: #00ED93;'>
          <ICountUp
            :delay="delay"
            :endVal="detail.actualReceivedMoneyCount"
            :options="options"
          />
        </div>
        <div class="summary-label">
          实际收取租金金额
        </div>
      </div>
    </div>
  </container>
</template>

<script>
  import container from "../container";
  import ICountUp from 'vue-countup-v2';
  import {getRentAreaMoneyCount} from "../../../../../api/bigData";

  export default {
    name: "dataSummary",
    components: {
      container,
      ICountUp,
    },
    data() {
      return {
        delay: 2000,
        options: {
          useEasing: true,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          prefix: '',
          suffix: ''
        },
        detail:{
          planRentArea:0,
          planReceivedMoneyCount:0,
          actualRentArea:0,
          actualReceivedMoneyCount:0,
        },
      }
    },
    methods: {
      getRentAreaMoneyCount(){
        getRentAreaMoneyCount({}).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.detail=data.content
          } else {

          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {

        })
      },
    },
    created() {
      this.getRentAreaMoneyCount()
    },
  }
</script>

<style scoped lang="scss">
  .data-summary {
    .summary{
      text-align: center;
      .summary-value{
        font-size:32px;
        font-family:Helvetica;
        color:rgba(255,70,75,1);
        line-height:38px;
      }
      .summary-label{
        font-size:16px;
        font-family:Helvetica;
        color:rgba(184,215,255,1);
        line-height:19px;
        margin-top: 4px;
      }
    }
  }
</style>
